import tw, { styled } from 'twin.macro';
import AnnouncementButton from '../AnnouncementButton/AnnouncementButton';
import { Container } from '../AnnouncementButton/AnnouncementButton.styles';

export const StyledSection = styled.section<{
  hideOnMobile: boolean;
  hasBackgroundColor: boolean;
}>`
  ${tw`px-2 lg:px-0`}
  ${({ hideOnMobile }) => hideOnMobile && tw`hidden md:block`}
  ${({ hasBackgroundColor }) => hasBackgroundColor && tw`bg-ui-colours-ui1`}
`;

export const StyledCtaContainer = styled.div<{
  align: Queries.kontent_item_section_introduction_elements_text_alignment_enum;
  hasShadowcastBackground: boolean;
}>`
  ${tw`flex`}
  ${tw`mt-2 lg:mt-3`}
  ${({ align, hasShadowcastBackground }) => {
    if (hasShadowcastBackground) {
      if (align === 'left') return tw`justify-start`;
      if (align === 'center') return tw`justify-center`;
    } else {
      if (align === 'left') return tw`justify-center lg:justify-start`;
      if (align === 'center') return tw`justify-center`;
    }
  }}
`;

export const StyledTextContainer = styled.div<{
  isReversed: boolean;
  imageLayout: 'withImageShadowcast' | 'withImage' | 'textOnly';
  align: Queries.kontent_item_section_introduction_elements_text_alignment_enum;
}>`
  ${tw`flex flex-col justify-center`}
  ${tw`col-start-1 col-end-13`}

  ${({ isReversed, imageLayout, align }) => {
    if (imageLayout === 'withImageShadowcast') {
      return tw`md:col-start-5 md:col-end-13 lg:col-start-4 lg:col-end-13 order-2`;
    }

    if (imageLayout === 'withImage') {
      return isReversed
        ? tw`lg:col-start-7 lg:col-end-12 lg:order-2`
        : tw`lg:col-start-1 lg:col-end-6 lg:order-1`;
    }

    if (align === 'left') return tw`lg:col-start-1 lg:col-end-9`;
    if (align === 'center') return tw`lg:col-start-3 lg:col-end-11`;
  }}
`;

export const StyledEyebrow = styled.div`
  ${tw`mb-2`}
  ${tw`font-inter font-semi-bold uppercase`}
  ${tw`text-tag-m`}
  ${tw`text-primary-p1`}
`;

export const StyledHeadline = styled.h2`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-secondary-s1`}
  ${tw`scroll-mt-[100px]`}
`;

export const StyledDescription = styled.div`
  ${tw`font-inter font-regular`}

  section {
    ${tw`pb-0`}
  }
`;

export const StyledContainer = styled.div<{
  align: Queries.kontent_item_section_introduction_elements_text_alignment_enum;
  isReversed: boolean;
  hasShadowcastBackground: boolean;
  size: Queries.kontent_item_section_introduction_elements_text_size_enum;
  hasDescription: boolean;
}>`
  ${tw`container container-stack-context`}
  ${tw`grid grid-cols-1 md:grid-cols-12`}

  ${({ align }) => {
    if (align === 'left') return tw`text-left`;
    if (align === 'center') return tw`text-center`;
  }}
  ${({ isReversed }) => isReversed && tw`lg:gap-4`};
  ${({ hasShadowcastBackground }) => hasShadowcastBackground && tw`md:gap-3 lg:gap-4`};

  ${StyledDescription} {
    section p {
      ${tw`text-body-l`}
    }
  }

  ${StyledHeadline} {
    ${({ size, hasDescription }) => {
      switch (size) {
        case 'large':
          return hasDescription
            ? [tw`text-mobile-display-xl lg:text-display-xl`, tw`mb-2 lg:mb-3`]
            : [tw`text-mobile-display-xl lg:text-display-xl`, tw`mb-0`];
        case 'medium':
          return hasDescription
            ? [tw`text-mobile-heading-l lg:text-heading-l`, tw`mb-2 lg:mb-[20px]`]
            : [tw`text-mobile-heading-l lg:text-heading-l`, tw`mb-0`];
        case 'small':
          return hasDescription
            ? [tw`text-mobile-heading-m lg:text-heading-m`, tw`mb-2`]
            : [tw`text-mobile-heading-m lg:text-heading-m`, tw`mb-0`];
      }
    }}
  }
`;

export const StyledAnnouncementButton = styled(AnnouncementButton)<{
  hasBackgroundColor: boolean;
  align: Queries.kontent_item_section_introduction_elements_text_alignment_enum;
}>`
  ${tw`mb-3`}

  ${Container} {
    ${({ align }) => {
      if (align === 'left') return tw`justify-start`;
      if (align === 'center') return tw`justify-center`;
    }}
  }
  ${({ hasBackgroundColor }) => hasBackgroundColor && tw`bg-ui-colours-ui1`}
`;

export const StyledInfoTag = styled.div`
  ${tw`w-full`}
  ${tw`mb-2`}
`;
